module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._g({
    staticClass: "ui_toggle",
    class: _vm.getCssClass
  }, _vm.$listeners), [_c('label', {
    staticClass: "ui_toggle-label",
    on: {
      "click": function($event) {
        _vm.inputVal = !_vm.inputVal
      }
    }
  }, [_vm._v(_vm._s(_vm.labelText))]), _c('div', {
    staticClass: "ui_toggle-btn"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputVal),
      expression: "inputVal"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.inputVal) ? _vm._i(_vm.inputVal, null) > -1 : (_vm.inputVal)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.inputVal,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.inputVal = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.inputVal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.inputVal = $$c
        }
      }
    }
  }), _c('label', {
    on: {
      "click": function($event) {
        _vm.inputVal = !_vm.inputVal
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a516b56","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppToggle/AppToggle.vue
// module id = 9a46d61542e35c501d63
// module chunks = 89